<template>
    <div id="current-location-container" :class="[reposition && 'mt-5']" v-if="viewpoint && floorplan">
        <div v-if="sector && sector.id" class="text-row" @click="onSectorClick">
            <h5>{{ sector.name }}</h5>

            <icon name="ci-sector" color="var(--accent)" scale="1.2" />
        </div>
        <div class="text-row" @click="onFloorplanClick">
            <h5>{{ floorplan.name }}</h5>

            <icon name="ci-layer" color="var(--accent)" scale="1.2" />
        </div>
        <div class="text-row" @click="onFloorplanClick">
            <h6>{{ viewpoint.name }}</h6>
            <icon name="ci-circle" color="var(--accent)" scale=".6" />
        </div>
    </div>
</template>
<script>
/**
 * Summary.
 * This UI component is used to show the current viewpoint and floorplan on viewer screen
 *
 * @param {Object} sector
 * @param {Object} floorplan
 * @param {Object} viewpoint
 *
 * @param {Boolean} reposition
 *
 * @event onViewpointClick(viewpoint)
 * @event onFloorplanClick(floorplan)
 */
export default {
    name: 'CurrentLocationDescription',
    props: {
        sector: Object,
        floorplan: Object,
        viewpoint: Object,

        reposition: Boolean,
    },
    methods: {
        onSectorClick() {
            this.$emit('onSectorClick', this.sector)
        },
        onFloorplanClick() {
            this.$emit('onFloorplanClick', this.floorplan)
        },
        onViewpointClick() {
            this.$emit('onViewpointClick', this.viewpoint)
        },
    },
}
</script>
<style lang="scss" scoped>
@import '@/scss/components/360Viewer/UI/current-location-description.scss';
</style>
